/* eslint-disable array-callback-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { green, orange, red } from "@mui/material/colors";
//import axios from "axios";
import { axiosinstance } from './axiosconfig';

const eventbgcolor = {
    'empty': green['700'],
    'full': orange['700'],
    'lock': red['700']
};

//------------------'booking/fetchBookingInOnePeriod' -> period
export const fetchBookingInOnePeriod = createAsyncThunk('booking/fetchBookingInOnePeriod', async (arg) => {
    const acttmplist = [];
    try {
        let res = await axiosinstance.get(
            `/pagebookdate/rsvn/s_date/${arg.s_date}/e_date/${arg.e_date}`
        );
      
        res.data.map(act => {
            Object.keys(act['lab']).map(el => {
                switch (el) {
                    case 'lab0': case 'lab1': case 'lab2': case 'lab3':
                    case 'lab6':
                        act['lab'][el].forEach(lb => {
                            let tmp = {};
                            let findobj = acttmplist.find(elem => elem.extendedProps?.resvcode === lb.resvcode);
                            //console.log('findobj ---> ', findobj, ' : lb -->', lb);
                            if (findobj !== undefined && findobj !== null) {
                                findobj.extendedProps.seatcount += lb.seatcount;
                                findobj.extendedProps.lab += lb.lab !== 'lab0' ? `, ${lb.lab} `.toUpperCase() : ',  รอกำหนด';
                                let index = acttmplist.findIndex(obj => obj.extendedProps.resvcode === lb.resvcode);
                                acttmplist[index] = findobj;
                            } else {
                                tmp = {
                                    //'title': `${lb.projcode} : ${lb.projname}`,
                                    'title': `${lb.projcode} : ${lb.direct} : ${lb.projname}`, //*** updated on 14-10-2024 */
                                    'start': act.dt_start,
                                    'end': act.dt_end,
                                    'extendedProps': {
                                        'resvcode': `${lb.resvcode}`,
                                        'directorate': `${lb.direct}`,
                                        'appvstatus': `${lb.appvstatus}`, //----> updated on 25-10-2024
                                        'lab': lb.lab !== 'lab0' ? ` ${lb.lab} `.toUpperCase() : 'รอกำหนด',
                                        'seatcount': lb.seatcount,
                                        'remainseat': act.seatremain,
                                        'totalseated': act.totalseated,
                                        'totalseat': act.totalseat
                                    },
                                    'description': `${lb.projname}`,
                                    'display': 'block',
                                    'color': act.seatremain[el] === 0 ? eventbgcolor['full'] : eventbgcolor['empty'],
                                    'allDay': false,
                                }
                            }

                            if (Object.keys(tmp).length !== 0) {
                                acttmplist.push(tmp);
                            }
                        });
                        break;
                        default:
                            break;
                }
            });
        });

        /*------------- added on 30-03-2024 ---------------*/
        acttmplist.map(act => {
            if (act.title.includes('LOC')) {
                act.title = act.description;
                act.color = eventbgcolor['lock'];
                act.extendedProps.seatcount = 0;
                act.extendedProps.lab = 'งดใช้ห้องสอบชั่วคราว';
            } else {
                /********** updated on 14-10-2024 ***************/
                let words = act.title.split(' : ');
                act.title = words[1].concat(' : ', words[2]);
            }
        });
        /*-------------------------------------------------*/
        //console.log('acttmplist ===> ', acttmplist);
        return (acttmplist);
    } catch (err) {
        console.log('PageBookDateSlice -> error : ', err);
    };
}
);


/*------------------------- added on 26-03-2024 -------------------------------*/
export const lockDateMngt = createAsyncThunk('booking/lockDateMngt',
    async (lockdatetime) => {
        try {
            let res = await axiosinstance.put(
                `/pagebookdate/lockDateMngt`, { lockdatetime }
            );
            return res;
        } catch (err) {
            console.log('PageBookDateSlice : lockDateMngt -> error : ', err);
        }
    });

export const fetchLockDateInfos = createAsyncThunk('booking/lockdateinfos',
    async (loc_date) => {
        try {
            let res = await axiosinstance.get(
                `/pagebookdate/getlockdateinfos/ldate/${loc_date}`
            );
            //console.log('102 : PgBookDateSlice ---> ', res);
            return res;
        } catch (err) {
            console.log('PageBookDateSlice : fetchLockDateInfos -> error : ', err);
        }
    });

/*-----------------------------------------------------------------------------*/

export const bookDateSlice = createSlice({
    name: 'bookdate', //slice or store name
    initialState: {
        bookdatearr: [],
        isLoading: false,
        error: null,
        datelocking: []//{ 'date': '', 'period': '', 'isLocking': false },
    },
    reducers: {
        /*setLockDate: (state, action) => {
            state.datelocking = [...state.datelocking, action.payload];
        },*/

    },
    extraReducers: (builder) => {
        /*----------------- fetchBookingInOnePeriod -------------*/
        builder.addCase(fetchBookingInOnePeriod.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(fetchBookingInOnePeriod.fulfilled, (state, action) => {
            state.isLoading = false;
            state.bookdatearr = action.payload;
        })
        builder.addCase(fetchBookingInOnePeriod.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })

        /*----------------- lockDateMngt -------------*/
        builder.addCase(lockDateMngt.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(lockDateMngt.fulfilled, (state, action) => {
            state.isLoading = false;
            //state.bookdatearr = action.payload;
        })
        builder.addCase(lockDateMngt.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })

        /*----------------- fetchLockDateInfos -------------*/
        builder.addCase(fetchLockDateInfos.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(fetchLockDateInfos.fulfilled, (state, action) => {
            state.isLoading = false;
            state.datelocking = action.payload;

        })
        builder.addCase(fetchLockDateInfos.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        })

    }
});//bookDateSlice

export const { setLockDate, setNewDate } = bookDateSlice.actions;
export default bookDateSlice.reducer;
